import * as React from 'react';
import { IStylingUser } from '../Entities';
import { ButtonToolbar, Button, Label, ButtonGroup } from 'react-bootstrap';
import { Translate } from '../../../shared/LanguageService';
import * as Features from '../../../shared/Features';
import ImpersonateButton from '../../../components/ImpersonateButton';

interface IStylingUsersListRowProps {
    stylingUser: IStylingUser;
    editStylingUser: (id: number) => void;
    viewlogs: (id: number) => void;
    deleteStylingUser: (id: number) => void;
    user: any
    showLogs: boolean;
    showStylingFirm: boolean;
}

const StylingUsersListRow = (props: IStylingUsersListRowProps) => {
    const canDeleteUser = props.user.details.id !== props.stylingUser.id;

    return (
        <tr>
            <td>{props.stylingUser.name}</td>
            <td>{Translate(props.stylingUser.role)}</td>
            <td>{props.stylingUser.email}</td>
            <td>{props.stylingUser.phoneNumber}</td>
            {props.showStylingFirm && <td>{props.stylingUser.stylingFirmName}</td>}
            <td className="tools">
                <ButtonToolbar className="pull-left btn-group-sm">
                    <ButtonGroup className="center">
                        <Button
                            onClick={() => props.editStylingUser(props.stylingUser.id)}
                            bsStyle="primary"
                        >
                            <i className="material-icons">edit</i>
                            {Translate('styling-firms/list/row/button-label/edit')}
                        </Button>
                        {props.showLogs && ( 
                          <Button onClick={() => props.viewlogs(props.stylingUser.id)} bsStyle="info">
                            <i className="material-icons">list</i>{' '}
                            {Translate('styling-firms/list/row/button-label/logs')}
                          </Button>
                        )}
                        {props.stylingUser.role === 'role/stylist' && (
                            <ImpersonateButton
                                userId={props.stylingUser.id}
                                afterLoginPath="/stylingcalendar"
                            />
                        )}
                        {props.stylingUser.role === 'role/styling-admin' && (
                            <ImpersonateButton
                                userId={props.stylingUser.id}
                                afterLoginPath="/stylingcalendars"
                            />
                        )}
                        {canDeleteUser && (
                          <Button
                            onClick={() => props.deleteStylingUser(props.stylingUser.id)}
                            bsStyle="danger"
                          >
                            <i className="material-icons">delete</i>{' '}
                            {Translate('styling-firms/list/row/button-label/delete')}
                          </Button>
                        )}
                    </ButtonGroup>
                </ButtonToolbar>
            </td>
        </tr>
    );
};

export default StylingUsersListRow;
